// src/pages/dashboard-organizador.js
import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, CircularProgress } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import StyledCardComponent from '../../constants/StyledCard'; // Asegúrate de que este archivo existe y está bien configurado
import axios from 'axios';
import {
  EmojiEvents as EmojiEventsIcon,
  Group as GroupIcon,
  Person as PersonIcon,
  Assessment as AssessmentIcon,
  People as PeopleIcon,
} from '@mui/icons-material';

const StatsOrganizador = () => {
  const [data, setData] = useState({
    competencias: { creadas: 0 },
    inscritos: 0,
    equipos: { creados: 0 },
    entrenadores: 0,
    resultados: { registrados: 0, pruebas: 0 },
    inscritosDiarios: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          competenciasRes,
          inscritosRes,
          equiposRes,
          entrenadoresRes,
          resultadosRes,
          inscritosDiariosRes,
        ] = await Promise.all([
          axios.get('/api/competencias'), // Asegúrate de que estas rutas son correctas
          axios.get('/api/inscritos'),
          axios.get('/api/equipos'),
          axios.get('/api/entrenadores'),
          axios.get('/api/resultados'),
          axios.get('/api/inscritos-diarios'),
        ]);

        setData({
          competencias: {
            creadas: competenciasRes.data.creadas || 0,
          },
          inscritos: inscritosRes.data.total || 0,
          equipos: {
            creados: equiposRes.data.creados || 0,
          },
          entrenadores: entrenadoresRes.data.total || 0,
          resultados: {
            registrados: resultadosRes.data.registrados || 0,
            pruebas: resultadosRes.data.pruebas || 0,
          },
          inscritosDiarios: inscritosDiariosRes.data || [],
        });
        setLoading(false);
      } catch (error) {
        console.error('Error al obtener los datos del dashboard:', error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          height: '80vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>
        Dashboard Organizador
      </Typography>

      <Grid container spacing={3}>
        {/* Competencias Card */}
        <Grid item xs={12} sm={6} md={3}>
          <StyledCardComponent
            icon={<EmojiEventsIcon sx={{ fontSize: 30, color: 'white' }} />}
            number={data.competencias.creadas}
            description="Competencias"
            color="#FFEDD5"
          />
        </Grid>

        {/* Inscritos Card */}
        <Grid item xs={12} sm={6} md={3}>
          <StyledCardComponent
            icon={<PeopleIcon sx={{ fontSize: 30, color: 'white' }} />}
            number={data.inscritos}
            description="Inscritos"
            color="#FDE68A"
          />
        </Grid>

        {/* Equipos Card */}
        <Grid item xs={12} sm={6} md={3}>
          <StyledCardComponent
            icon={<GroupIcon sx={{ fontSize: 30, color: 'white' }} />}
            number={data.equipos.creados}
            description="Equipos"
            color="#D1FAE5"
          />
        </Grid>

        {/* Entrenadores Card */}
        <Grid item xs={12} sm={6} md={3}>
          <StyledCardComponent
            icon={<PersonIcon sx={{ fontSize: 30, color: 'white' }} />}
            number={data.entrenadores}
            description="Entrenadores"
            color="#E0E7FF"
          />
        </Grid>

        {/* Resultados Card */}
        <Grid item xs={12} sm={6} md={3}>
          <StyledCardComponent
            icon={<AssessmentIcon sx={{ fontSize: 30, color: 'white' }} />}
            number={`${data.resultados.registrados}/${data.resultados.pruebas}`}
            description="Resultados"
            color="#F5F3FF"
          />
        </Grid>
      </Grid>

      {/* Gráfica de Inscripciones Diarias */}
      <Box sx={{ marginTop: 5 }}>
        <Typography variant="h5" gutterBottom>
          Inscripciones Diarias
        </Typography>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data.inscritosDiarios}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="fecha" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Line type="monotone" dataKey="inscritos" stroke="#8884d8" activeDot={{ r: 8 }} />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default StatsOrganizador;
